import React, { useEffect, useState } from "react";

import SearchBar from "../../components/Searchbar";
import ButtonBlue from "../../components/Button/ButtonBlue";

import { MdOutlinePeopleAlt } from "react-icons/md";
import { IoMdArchive } from "react-icons/io";

import "../../styles/group.styles.scss";
import GroupCard from "./GroupCard";
import axios from 'axios';
import { staticFiles } from "../../components/Helpers/Static";
import { serverUrl } from '../../components/Helpers/Config'
import { useHistory, useLocation } from "react-router-dom";
import { SET_SHOWCASE } from "../../redux/actions";
import SharePost from "./SharePost";
import { useDispatch, useSelector } from "react-redux";
import { showSharepost } from "../../redux/actions/sharePost";
import { getCommunityGroups } from "../../redux/actions/communityGroups";
import { active } from "sortablejs";
import Tab from "../Footer/Tab"
import { ActiveDiv, ArchiveDiv, ButtonCommonTop, ButtonCommonTopNew, SideBarActiveDivNew, SideBarNormalDivNew } from "../Theme";
import { HiShare } from "react-icons/hi";
import Loading from "../../components/Button/Loading";
import Loader, { CommunityLoader } from "../../components/Button/Loader";
function Group() {
  const history = useHistory()
  const location = useLocation()
  const groups = useSelector(state => state.communityGroups.groups)
  const loading = useSelector(state => state.communityGroups.loading)
  const [isActive, setIsActive] = useState(true);
  const [currentText, setCurrentText] = useState("Active");
  const [communityGroups, setGroups] = useState([]);
  const [searchField, setSearchField] = useState('')
  const [nonPinnedGroups, setNonPinnedGroups] = useState([])
  const [pinnedGroups, setPinnedGroups] = useState([])
  const [searchedGroups, setSearchedGroups] = useState([])

  const [isStudent, setisStudent] = useState(false);
  const [isTutor, setisTutor] = useState(false);

  const dispatch = useDispatch()
  const userProfile = useSelector(state => state.auth.user)
  useEffect(() => {
    if (isTutor || isStudent) {
      dispatch(getCommunityGroups(isTutor, isStudent))
    }
  }, [isTutor, isStudent])

  useEffect(() => {
    if (userProfile.role === "MANAGER") {
      setisTutor(true);
      setisStudent(false);
    }
    if (userProfile.role === "MEMBER") {
      setisTutor(false);
      setisStudent(true);
    }
  }, [userProfile])

  useEffect(() => {

    let filteredList = [];

    if (isActive) {
      filteredList = groups.filter(group =>
      (
        !group.is_parent ? group.is_community_archived === false : group.is_parent_archived === false
      )
      )
    }
    else {
      filteredList = groups.filter(group =>
      (
        !group.is_parent ? group.is_community_archived === true : group.is_parent_archived === true
      )
      )
    }

    // Search
    const searched = filteredList.filter(item =>
      Object.keys(item).some(key =>
        item[key]?.toString()?.toLowerCase()?.includes(searchField?.toLowerCase())
      )
    )
    setSearchedGroups(searched)
    setPinnedGroups(filteredList.filter(item => item.is_pinned === true))
    setNonPinnedGroups(filteredList.filter(item => item.is_pinned !== true));

  }, [groups, searchField, isActive])


  const ToggleView = ({ text, active, icon, ...props }) => {

    const handleActive = () => {
      if (currentText != text) {
        setIsActive(!isActive)
        setCurrentText(text)
      }
    }

    let styles = "h-full flex items-center rounded-full px-6 md:px-8 md:mr-8 cursor-pointer";

    return (
      active ?
        <ButtonCommonTop className={styles} onClick={() => handleActive(text)}>
          {icon}
          {text}
        </ButtonCommonTop> :
        <ArchiveDiv className={styles} onClick={() => handleActive(text)}>
          {icon}
          {text}
        </ArchiveDiv>
    );
  };

  return (<>
    {
      loading ?
        <CommunityLoader /> :
        <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
          <div className='w-full backGroundColor pb-6'>
            <div className="flex justify-between flex-col sm:flex-row gap-3 sm:gap-0 cardBackgroundColor p-4 pb-4 mb-4 px-5 items-center">
              <div>
                <SearchBar
                  setSearchField={setSearchField}
                />
              </div>
              <div className="flex gap-3">
                {isActive ?
                  <div className="flex gap-2 items-center">
                    <input
                      type="checkbox"
                      className="cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={isActive}
                      onChange={() => {
                        setIsActive(true);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Active
                    </span>
                    <input
                      type="checkbox"
                      className=" cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={!isActive}
                      onChange={() => {
                        setIsActive(false);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Archive
                    </span>
                  </div>
                  :
                  <div className="flex gap-2 items-center">
                    <input
                      type="checkbox"
                      className="cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={isActive}
                      onChange={() => {
                        setIsActive(true);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Active
                    </span>
                    <input
                      type="checkbox"
                      className=" cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={!isActive}
                      onChange={() => {
                        setIsActive(false);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Archive
                    </span>
                  </div>
                }
              </div>
              <div className="lg:hidden" id="hideDropDown">
                <ButtonCommonTopNew className="w-28 flex items-center whitespace-nowrap px-2 gap-1 border p-2 text-sm rounded-lg cursor-pointer" onClick={() => dispatch(showSharepost())}>
                  <HiShare fontSize="small" className="w-4 h-4 cursor-pointer primaryIcon" />
                  Share Post
                </ButtonCommonTopNew>
              </div>
            </div>
            <div className="mt-4">
              {searchField.length > 0 &&
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-5">
                  {searchedGroups.map((item, idx) => (
                    <div
                      key={idx}
                      className='cardBackgroundColor shadow-sm border20px overflow-hidden relative cursor-pointer w-full'
                      onClick={() => history.push(
                        `/community/groups/${item.id}`,
                        { src: location.pathname, active: isActive })}
                    >
                      <GroupCard item={item} is_student={isStudent} is_tutor={isTutor} isActive={isActive} />
                    </div>

                  ))
                  }
                </div>
              }
              {searchField.length === 0 && pinnedGroups.length > 0 &&
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-5">
                  {pinnedGroups.map((item, idx) => (
                    <div
                      key={idx}
                      className='cardBackgroundColor shadow-sm border20px overflow-hidden relative cursor-pointer w-full'
                      onClick={() => history.push(
                        `/community/groups/${item.id}`,
                        { src: location.pathname, active: isActive }
                      )}
                    >
                      <GroupCard item={item} is_student={isStudent} is_tutor={isTutor} isActive={isActive} />
                    </div>
                  ))}
                </div>
              }
              {searchField.length === 0 && nonPinnedGroups.length > 0 &&
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-5">
                  {nonPinnedGroups.map((item, idx) => (
                    <div
                      key={idx}
                      className='cardBackgroundColor shadow-sm border20px overflow-hidden relative cursor-pointer w-full'
                      onClick={() => history.push(
                        `/community/groups/${item.id}`,
                        { src: location.pathname, active: isActive }
                      )}
                    >
                      <GroupCard item={item} is_student={isStudent} is_tutor={isTutor} />
                    </div>

                  ))}
                </div>
              }
            </div>
          </div>
        </div>}
  </>);
}

export default Group;
